const channels = [
  {
    icon: 'ri-mail-line',
    title: '电子邮件',
    desc: 'hello@woaimanhua.example',
    note: '投稿、合作与建议，欢迎来信',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: '站长交流群',
    desc: '漫画迷交流社区',
    note: '与同好分享你的追更清单',
  },
  {
    icon: 'ri-time-line',
    title: '服务时间',
    desc: '全年无休',
    note: '追更不打烊，反馈都会回复',
  },
];

export default function AboutContact() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold tracking-wide text-secondary-800">联系方式</span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">和我们保持联系</h2>
          <p className="mt-4 text-foreground-600">有任何建议、问题或合作意向，都欢迎通过以下方式找到我们。</p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {channels.map((c) => (
            <div
              key={c.title}
              className="rounded-2xl border border-background-200/70 bg-background-50 p-6 text-center"
            >
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 text-lg font-bold text-foreground-950">{c.title}</h3>
              <p className="mt-1 text-sm font-medium text-primary-700">{c.desc}</p>
              <p className="mt-1 text-xs text-foreground-500">{c.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}